import Permission from '@/enums/Permission';
import { usePermissions } from '@/composables/usePermissions';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useVoucherFileData(voucherId: number) {
    const { hasPermission } = usePermissions();
    const { data: files, isPlaceholderData: isPlaceholderDataFiles } = useQuery({
        queryKey: ['voucher-files', voucherId],
        queryFn: async () => {
            const { data } = await axios.get(
                hasPermission(Permission.VOUCHERS_OWN_VIEW) && !hasPermission(Permission.VOUCHERS_VIEW) ?
                route('v2.voucher.own.files.info', { voucher: voucherId }) :
                route('v2.voucher.files.info', { voucher: voucherId }),
            );
            return data;
        },
        placeholderData: [],
    });

    return {
        files,
        isPlaceholderDataFiles,
    };
}
